module.exports = __webpack_public_path__ + "static/media/pizza-image-1.2e5aacd1.png";